export interface Holding {
  name: string;
  allocation: string;
  fundId: string;
  funds: HoldingFund[];
}

export interface HoldingFund {
  name: string;
  allocation: string;
}

export interface HoldingsRequestPayload {
  account: string;
  date: string;
  country: string;
  allocationType?: string;
}

export interface HoldingsFileRequestPayload {
  account: string;
  date: string;
  fund: string;
  type?: string;
  userDate?: string;
  allocationType?: string;
}

export interface HoldingsFilter {
  year?: number;
  month?: number;
  allocationType?: string;
}

export interface HoldingsTableItem {
  name: string;
  color: string;
  allocation: string;
}

export interface HoldingsChartData {
  id?: string;
  parent?: string;
  name: string;
  value: number;
  color?: string;
}
export interface allocationTypeOption {
  value: string;
  label: string;
}

export const
  allocationTypeOptions: allocationTypeOption[] = [
    {
      value: 'managerAllocations',
      label: `Manager Allocations`
    },
    {
      value: 'regionAllocations',
      label: `Region Allocations`
    },
    {
      value: 'sectorAllocations',
      label: `Sector Allocations`
    }
  ];
